import React, { Component } from 'react';
import ReportsLayout from '../../templates/reports';
import Employees from '../../elements/reports/employees';
import Loading from './../../elements/loading';

class ReportsEmployees extends Component{
	render (){
		const { reports, revision } = this.props;
		const { employees } = reports;
		return (
			(revision.isFetching || employees.isFetching) ? <Loading/>:<Employees {...this.props}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		//this.props.fetchRevisions(modality, state, municipality);
		this.props.reportsEmployees(modality, state, municipality);

	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {
			//this.props.fetchRevisions(modality, state, municipality);
			this.props.reportsEmployees(modality, state, municipality);
		}
	}
}

export default ReportsLayout(ReportsEmployees, {subnav: 3});


// WEBPACK FOOTER //
// ./src/layouts/reports/employees.jsx